import {css} from 'lit';
export const styles = css`canvas{background-color:green}`;
export default styles;
